module.exports = __webpack_public_path__ + "static/media/bg.0664c441.jpg";